<template>
  <div class="modal fade" id="configModal" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
      <div class="modal-content">
        <div class="modal-header config-desktop-header">
          <h5 class="modal-title">{{ $t("settings.settings") }}</h5>
          <i class="bi-x close-modal" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-header config-mobile-header">
          <button
            v-if="mobileSection"
            type="button"
            class="config-back-btn"
            aria-label="返回"
            @click="mobileBack"
          >
            <i class="bi-chevron-left" aria-hidden="true"></i>
          </button>
          <span v-else class="config-back-spacer" aria-hidden="true"></span>
          <h5 class="modal-title">{{ mobileTitle }}</h5>
          <i class="bi-x close-modal" data-bs-dismiss="modal"></i>
        </div>
        <div class="modal-body px-0 config-modal-body" :class="{ 'is-drilling': !!mobileSection }">
          <ul class="nav nav-tabs" id="confTab" role="tablist" style="display: none">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="config-home-tab" data-bs-toggle="tab" data-bs-target="#config-home"
                role="tab">
                Home
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="config-general-tab" data-bs-toggle="tab" data-bs-target="#config-general"
                role="tab">
                General
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="config-display-tab" data-bs-toggle="tab" data-bs-target="#config-display"
                role="tab">
                Display
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="config-notifications-tab" data-bs-toggle="tab"
                data-bs-target="#config-notifications" role="tab">
                Notifications
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="config-language-tab" data-bs-toggle="tab" data-bs-target="#config-language"
                role="tab">
                Language
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="config-behavior-tab" data-bs-toggle="tab" data-bs-target="#config-behavior"
                role="tab">
                Behavior
              </button>
            </li>
          </ul>

          <div id="config-links-menu" class="tab-pane fade show config-links-menu">
            <link-list :linkList="configLinks"></link-list>
          </div>

          <nav class="config-mobile-root" aria-label="settings sections">
            <button
              v-for="item in configLinks"
              :key="item.link"
              type="button"
              class="config-mobile-row"
              @click="openMobileSection(item)"
            >
              <i :class="item.ico" aria-hidden="true"></i>
              <span class="config-mobile-row-label">{{ item.name }}</span>
              <i class="bi-chevron-right config-mobile-chevron" aria-hidden="true"></i>
            </button>
          </nav>

          <div class="tab-content px-4 config-tab-content" id="confTab-content">
            <div class="tab-pane fade active show" id="config-general">
              <div class="d-flex flex-column mt-2 h-100 config-section">
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="calendarSetting">{{ $t("settings.calendar") }}</label>
                  <input class="form-check-input" type="checkbox" id="calendarSetting" v-model="configData.calendar"
                    @change="changeConfig('calendar', configData.calendar)" />
                </div>

                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="customListsSetting">{{ $t("settings.customLists")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="customListsSetting" v-model="configData.customList"
                    @change="changeConfig('customList', configData.customList)" />
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="config-behavior">
              <div class="d-flex flex-column mt-2 h-100 config-section">
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="moveOldTasks">{{ $t("settings.moveOldTasks")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="moveOldTasks" v-model="configData.moveOldTasks"
                    @change="changeConfig('moveOldTasks', configData.moveOldTasks)" />
                </div>
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="weekStartOnMonday">{{ $t("settings.weekStartOnMonday")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="weekStartOnMonday" v-model="configData.weekStartOnMonday"
                    @change="changeConfig('weekStartOnMonday', configData.weekStartOnMonday)" />
                </div>
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="moveOldTasks">{{ $t("settings.startCalendarYesterday")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="moveOldTasks"
                    v-model="configData.startCalendarYesterday"
                    @change="changeConfig('startCalendarYesterday', configData.startCalendarYesterday)" />
                </div>
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="autoReorderTasks">{{ $t("settings.autoReorderTasks")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="autoReorderTasks"
                    v-model="configData.autoReorderTasks"
                    @change="changeConfig('autoReorderTasks', configData.autoReorderTasks)" />
                </div>
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="moveCompletedTaskToBottom">{{
                    $t("settings.moveCompletedTaskToBottom")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="moveCompletedTaskToBottom"
                    v-model="configData.moveCompletedTaskToBottom"
                    @change="changeConfig('moveCompletedTaskToBottom', configData.moveCompletedTaskToBottom)" />
                </div>
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label flex-fill" for="moveCompletedSubTaskToBottom">{{
                    $t("settings.moveCompletedSubTaskToBottom")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="moveCompletedSubTaskToBottom"
                    v-model="configData.moveCompletedSubTaskToBottom"
                    @change="changeConfig('moveCompletedSubTaskToBottom', configData.moveCompletedSubTaskToBottom)" />
                </div>
                <div class="px-1 mb-3">
                  <label for="notesEditorMode" class="form-check-label">{{
                    $t("settings.notesEditorMode")
                  }}</label>
                  <select
                    id="notesEditorMode"
                    class="form-select mt-2"
                    v-model="configData.notesEditorMode"
                    @change="changeConfig('notesEditorMode', configData.notesEditorMode)"
                  >
                    <option value="light">{{ $t("settings.notesEditorModeLight") }}</option>
                    <option value="focus">{{ $t("settings.notesEditorModeFocus") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="config-display">
              <div class="d-flex flex-column mt-2 h-100 config-section">


                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label" for="darkThemeSetting">{{
                    $t("settings.darkTheme")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="darkThemeSetting" v-model="configData.darkTheme"
                    @change="changeConfig('darkTheme', configData.darkTheme)" />
                </div>

                <div class="horizontal-divider mb-3"></div>
                <div class="px-1 mb-3">
                  <label for="columnsConfig" class="form-check-label">{{ $t("settings.columns") }}: {{
                    configData.columns
                  }}</label>
                  <input type="range" class="form-range mt-2 px-2" min="1" max="12" id="columnsConfig"
                    v-model="configData.columns" @change="changeConfig('columns', configData.columns)" />
                </div>

                <div class="px-1 mb-3">
                  <label for="columnsConfig" class="form-check-label">{{ $t("settings.lists_columns") }}: {{
                    configData.customColumns
                  }}</label>
                  <input type="range" class="form-range mt-2 px-2" min="1" max="12" id="columnsConfig"
                    v-model="configData.customColumns"
                    @change="changeConfig('customColumns', configData.customColumns)" />
                </div>

                <div class="px-1 mb-3 zoom-config">
                  <label for="zoomConfig" class="form-check-label">{{ $t("settings.zoom") }}: {{ configData.zoom
                  }}%</label>
                  <input type="range" class="form-range mt-2 px-2" min="50" max="200" id="zoomConfig" step="5"
                    v-model="configData.zoom" @change="changeConfig('zoom', configData.zoom)" />
                </div>

                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label" for="compactViewSetting">{{
                    $t("settings.compactView")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="compactViewSetting" v-model="configData.compactView"
                    @change="changeConfig('compactView', configData.compactView)" />
                </div>
                <div class="form-check form-switch d-flex px-1 mb-3 justify-content-between">
                  <label class="form-check-label" for="fullscreenToDoModal">{{
                    $t("settings.fullscreenToDoModal")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="fullscreenToDoModal"
                    v-model="configData.fullscreenToDoModal"
                    @change="changeConfig('fullscreenToDoModal', configData.fullscreenToDoModal)" />
                </div>
                <div class="px-1 mb-3">
                  <label class="form-label d-block mb-2" for="defaultCalendarView">{{
                    $t("settings.defaultCalendarView")
                  }}</label>
                  <select
                    id="defaultCalendarView"
                    class="form-select"
                    v-model="configData.defaultCalendarView"
                    @change="changeConfig('defaultCalendarView', configData.defaultCalendarView)"
                  >
                    <option value="day">{{ $t("settings.defaultCalendarViewDay") }}</option>
                    <option value="week">{{ $t("settings.defaultCalendarViewWeek") }}</option>
                    <option value="month">{{ $t("settings.defaultCalendarViewMonth") }}</option>
                    <option value="year">{{ $t("settings.defaultCalendarViewYear") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="config-notifications">
              <div class="d-flex flex-column mt-3 h-100 config-section">
                <div class="form-check form-switch d-flex px-0 mb-3  justify-content-between">
                  <label class="form-check-label" style="margin-left: 0px" for="notificationIndicator">{{
                    $t("settings.notificationIndicator")
                  }}</label>
                  <input class="form-check-input" type="checkbox" id="notificationIndicator"
                    v-model="configData.notificationIndicator"
                    @change="changeConfig('notificationIndicator', configData.notificationIndicator)" />
                </div>

                <div class="horizontal-divider mb-3"></div>

                <label for="notificationSound" class="form-label">{{ $t("settings.notificationSound") }}:</label>
                <div class="d-flex">
                  <select id="notificationSound" class="col-sm-9 form-select flex-fill"
                    aria-label="Default select example" v-model="configData.notificationSound" @change="
                      changeConfig('notificationSound', configData.notificationSound)
                      ">
                    <option value="none">None</option>
                    <option value="pop">Pop</option>
                    <option value="bell">Bell</option>
                    <option value="soft-bell">Soft Bell</option>
                    <option value="soft">Soft</option>
                    <option value="tiny">Tiny</option>
                    <option value="piano">Piano</option>
                    <option value="positive">Positive</option>
                    <option value="metal">Metal</option>
                  </select>
                  <button class="btn" style="margin-left: 8px" type="button" @click="playSound">
                    <i class="bi-play-circle a"></i>
                  </button>
                </div>
              </div>


            </div>
            <div class="tab-pane fade" id="config-language">
              <div class="d-flex flex-column mt-2 h-100 config-section">
                <label for="language" class="form-label">{{ $t("settings.language") }}:</label>
                <select id="language" class="col-sm-9 form-select" aria-label="Default select example"
                  v-model="configData.language" @change="setLanguage">
                  <option value="en">English</option>
                  <option value="es">Español</option>
                  <option value="fr">Français</option>
                  <option value="de">Deutsch</option>
                  <option value="it">Italiano</option>
                  <option value="pt">Português</option>
                  <option value="ru">русский</option>
                  <option value="hi">हिंदी</option>
                  <option value="ja">日本</option>
                  <option value="pl">Polski</option>
                  <option value="ar">عرب</option>
                  <option value="ko">한국어</option>
                  <option value="zh_cn">简体中文</option>
                  <option value="zh_tw">繁體中文</option>
                  <option value="uk">український</option>
                  <option value="tr">Türk</option>
                  <option value="vi">Tiếng Việt</option>
                  <option value="he">עִברִית</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 1056">
      <toast-message ref="invalidFile" id="invalidFile" text="$t('settings.invalidFile')"></toast-message>
    </div>
  </div>
</template>

<script>
import configRepository from "../repositories/configRepository";
import toastMessage from "../components/toastMessage";
import linkList from "../components/linkList";
import configList from "./configList";
import notifications from "../helpers/notifications";
const { loadLocaleMessages } = require("../assets/languages/languages.js");

export default {
  name: "configModal",
  components: { toastMessage, linkList },
  props: {
    configProp: { required: true },
  },
  data() {
    return {
      configData: this.$store.getters.config,
      mobileSection: null,
    };
  },
  computed: {
    configLinks() {
      return configList.configList(this);
    },
    mobileTitle() {
      if (!this.mobileSection) return this.$t("settings.settings");
      const item = this.configLinks.find((link) => link.link === this.mobileSection);
      return item ? item.name : this.$t("settings.settings");
    },
  },
  watch: {
    configProp(newVal) {
      this.configData = newVal;
    },
  },
  mounted() {
    const el = document.getElementById("configModal");
    if (!el) return;
    this._onModalShow = () => {
      this.mobileSection = null;
    };
    this._onModalHide = () => {
      this.mobileSection = null;
    };
    el.addEventListener("show.bs.modal", this._onModalShow);
    el.addEventListener("hidden.bs.modal", this._onModalHide);
  },
  beforeUnmount() {
    const el = document.getElementById("configModal");
    if (!el) return;
    el.removeEventListener("show.bs.modal", this._onModalShow);
    el.removeEventListener("hidden.bs.modal", this._onModalHide);
  },
  methods: {
    changeConfig(key, val) {
      this.$nextTick(async () => {
        this.$store.commit("updateConfig", { val: val, key: key });
        configRepository.update(this.$store.getters.config);
        if (key === "language") {
          await loadLocaleMessages(this.$i18n, this.configData.language);
        }
        if (key === "columns") {
          setTimeout(() => {
            this.$emit("changeColumns");
          }, 50);
        }
      });
    },
    goHome() {
      document.getElementById("config-home-tab").click();
    },
    setLanguage() {
      this.changeConfig("language", this.configData.language);
    },
    playSound() {
      notifications.playNotificationSound(this.$store.getters.config.notificationSound);
    },
    openMobileSection(item) {
      this.mobileSection = item.link;
      this.$nextTick(() => {
        const tab = document.getElementById(item.link);
        if (tab) tab.click();
      });
    },
    mobileBack() {
      this.mobileSection = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/style/globalVars";

.form-check-input {
  width: 2.8em !important;
  height: 1.4em !important;
  flex-shrink: 0;
  margin-top: 0 !important;
  margin-left: 0 !important;
}

.config-modal-body {
  display: flex;
  min-width: 0;
}

.config-links-menu {
  flex: 0 0 220px;
  width: 220px;
  border-right: 1px solid rgba(0, 0, 0, 0.06);

  .dark-theme & {
    border-right: 1px solid rgba(255, 255, 255, 0.06);
  }
}

.config-mobile-root,
.config-mobile-header {
  display: none;
}

.config-tab-content {
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
  height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}

.config-tab-content .form-check.form-switch {
  align-items: center;
  gap: 12px;
}

.icons {
  font-size: 18px;
  margin-right: 5px;
}

.form-check-label {
  margin-left: 0;
  padding-top: 0;
  min-width: 0;
}

.dark-theme .form-select {
  background-color: #15161e;
  border: 1px solid #30363d;
  color: #c9d1d9;
}

.form-select:focus {
  box-shadow: none;
}

.modal-dialog {
  max-width: 800px;
  max-height: 500px;
}

@media (max-width: 767.98px) {
  .modal-dialog {
    max-width: none;
    max-height: none;
    margin: 0;
  }

  .config-desktop-header {
    display: none !important;
  }

  .config-mobile-header {
    display: flex !important;
    align-items: center;
    gap: 4px;
    padding: 12px 12px 12px 8px;
  }

  .config-mobile-header .modal-title {
    flex: 1;
    text-align: center;
    margin: 0;
    font-size: 17px;
    font-weight: 600;
  }

  .config-back-btn,
  .config-back-spacer,
  .config-mobile-header .close-modal {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .config-back-btn {
    border: none;
    background: transparent;
    color: inherit;
    font-size: 1.35rem;
    padding: 0;
    border-radius: 10px;
  }

  .config-back-btn:active {
    background: rgba(0, 0, 0, 0.06);
  }

  .dark-theme .config-back-btn:active {
    background: rgba(255, 255, 255, 0.08);
  }

  .config-modal-body {
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    background: #f2f2f7;
  }

  .dark-theme .config-modal-body {
    background: #0d1117;
  }

  .config-links-menu {
    display: none !important;
  }

  .config-mobile-root {
    display: flex;
    flex-direction: column;
    gap: 0;
    margin: 16px 16px 24px;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
  }

  .dark-theme .config-mobile-root {
    background: #161b22;
  }

  .config-modal-body.is-drilling .config-mobile-root {
    display: none;
  }

  .config-mobile-row {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 52px;
    padding: 12px 14px;
    border: none;
    border-bottom: 1px solid rgba(60, 60, 67, 0.12);
    background: transparent;
    color: inherit;
    text-align: start;
    font-size: 16px;
  }

  .dark-theme .config-mobile-row {
    border-bottom-color: rgba(255, 255, 255, 0.1);
  }

  .config-mobile-row:last-child {
    border-bottom: none;
  }

  .config-mobile-row:active {
    background: rgba(0, 0, 0, 0.04);
  }

  .config-mobile-row > i:first-child {
    width: 1.4rem;
    text-align: center;
    font-size: 1.15rem;
    color: #0d6efd;
  }

  .config-mobile-row-label {
    flex: 1;
    min-width: 0;
  }

  .config-mobile-chevron {
    color: rgba(60, 60, 67, 0.35);
    font-size: 0.95rem;
  }

  .dark-theme .config-mobile-chevron {
    color: rgba(255, 255, 255, 0.35);
  }

  .config-tab-content {
    display: none;
    width: 100%;
    height: auto;
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 16px !important;
  }

  .config-modal-body.is-drilling .config-tab-content {
    display: block;
  }

  .config-section {
    margin: 0;
    padding: 4px 12px;
    border-radius: 12px;
    background: #fff;
  }

  .dark-theme .config-section {
    background: #161b22;
  }

  .config-section > .form-check,
  .config-section > .px-1,
  .config-section > .d-flex,
  .config-section > .horizontal-divider,
  .config-section > label,
  .config-section > div > .form-check {
    margin-bottom: 0 !important;
    min-height: 48px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(60, 60, 67, 0.12);
  }

  .dark-theme .config-section > .form-check,
  .dark-theme .config-section > .px-1,
  .dark-theme .config-section > .d-flex,
  .dark-theme .config-section > label,
  .dark-theme .config-section > div > .form-check {
    border-bottom-color: rgba(255, 255, 255, 0.1);
  }

  .config-section > .horizontal-divider {
    min-height: 0;
    padding: 0;
    border-bottom: none;
    margin: 0 !important;
    opacity: 0.35;
  }

  .config-section > :last-child,
  .config-section > div > .form-check:last-child {
    border-bottom: none !important;
  }

  .config-section .btn {
    width: auto !important;
    min-width: 96px;
  }
}

.form-range::-webkit-slider-thumb {
  background: $check-color;

  .dark-theme & {
    background: $dt-check-color;
  }
}

.form-range::-webkit-slider-thumb {
  background: $check-color;

  .dark-theme & {
    background: $dt-check-color;
  }
}

.form-range::-ms-thumb {
  background: $check-color;

  .dark-theme & {
    background: $dt-check-color;
  }
}

@-moz-document url-prefix() {
  .zoom-config {
    display: none;
  }
}
</style>